<template>
  <div class="lianmai-container" :class="{'lianmai-container-guest': role !== 3}">
    <!-- 连麦申请列表 -->
    <div class="lianmai-list" v-if="liveStartStatus == 2">
      <div class="lianmai-list-header">
        <span class="fontsize12 fontColor">{{ $t("lianmai.连麦申请") }}({{ applyUserList.length }})</span>
        <span v-show="role===3" class="fontsize12 lianmai-refuseAll" @click="applyUserList.length > 0 && refuseUserVoip()">{{
          $t("lianmai.refuseAll") }}</span>
      </div>
      <div class="lianmai-list-search">
        <el-input :placeholder="$t('lianmai.searchApplyer')" class="form-dark lianMaiSearch" v-model="cacheSearchName"
          clearable @keyup.native="searchFunc(false)" @keyup.enter.native="searchFunc(true)" @blur="searchFunc(true)"
          @clear="clearSearchFunc">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <!-- 连麦列表 -->
      <RecycleScroller class="controller-list scrollbar" :items="searchName ? searchApplyUserList : applyUserList"
        :item-size="50" key-field="uid" v-slot="{ item, index }">
        <div class="controller-list-content">
          <span class="fontsize12 controller-list-name textoverflow fontColor">{{ index + 1 }}&nbsp;&nbsp;
            <div class="controller-icon">
              <img :src="require('@/svg/pc_device.svg')" v-if="item.device == 1" />
              <img :src="require('@/svg/mobile_device.svg')" v-if="item.device == 0" />
            </div>
            <span class="nickname">{{ item.name }}</span>
          </span>
          <div class="device-icon">
            <!-- videoDevice：-1 未设置 videoDevice  0 没有设备  1 开启视频  2 关闭视频  3 视频检测失败【注：videoDevice 为空或者0不显示图标，为3显示不可用图标且不可点击】 -->
            <img
              :src="(item.videoDevice === 1 || item.videoDevice === 3) ? require('@/svg/camera_small_grey.svg') : require('@/svg/camera_small_close_grey.svg')"
              :class="{ 'opacity-0': !item.videoDevice || item.videoDevice < 0, 'disabled': !(item.videoDevice === 1 || item.videoDevice === 2) }"
              @click="(item.videoDevice === 1 || item.videoDevice === 2) && switchParticipantAVStatusFunc('video', item)" />
            <!-- audioDevice：-1 未设置 audioDevice  0 没有设备  1 开启音频  2 关闭音频  3 音频检测失败【注：vaudioDevice 为空或者0不显示图标，为3显示不可用图标且不可点击】 -->
            <img
              :src="item.audioDevice === 1 ? require('@/svg/mic_small_grey.svg') : require('@/svg/mic_small_close_grey.svg')"
              :class="{ 'opacity-0': !item.audioDevice || item.audioDevice < 0, 'disabled': !(item.audioDevice === 1 || item.audioDevice === 2) }"
              @click="(item.audioDevice === 1 || item.audioDevice === 2) && switchParticipantAVStatusFunc('audio', item)" />
          </div>

          <!-- qgs: 这里将 v-if v-else 改成 v-show 是因为刷新列表时涉及到重新渲染导致页面出现的 bug ——— 67041 【音视频连麦】主播开启/关闭连麦观众的设备，连麦列表按钮颜色会闪一下 -->
          <div v-show="role===3 && (item.status === 1 || item.status === 3)" class="controller-list-handel">
            <el-button @click="(item.status === 1 || item.status === 3) && setAgreeReplyFunc(item)" size="mini"
              type="primary" class="blueBtn">{{ $t("lianmai.同意") }}</el-button>

            <el-button @click="(item.status === 1 || item.status === 3) && setVoipReplyFunc(item, '0')" size="mini"
              class="greyBtn">
              {{ $t("lianmai.拒绝") }}
            </el-button>
          </div>
          <div v-show="role!==3 && (item.status === 1 || item.status === 3)" class="controller-list-handel">
            <font class="fontsize12 lianmaiconnect">{{ $t("lianmai.正在申请") }}</font>
          </div>
          <div v-show="!(item.status === 1 || item.status === 3)" class="controller-list-handel">
            <font v-if="item.status === 2" class="fontsize12 lianmaing">{{ $t("lianmai.connecting") }}</font>
            <el-button v-show="role===3" @click="!(item.status === 1 || item.status === 3) && setVoipReplyFunc(item, '3')" size="mini"
              type="danger" class="rebBtn">
              {{ $t("lianmai.挂断") }}
            </el-button>
          </div>
        </div>
      </RecycleScroller>
    </div>

    <LianmaiSetting :opType="opType" :isShowSetting="isShowSetting" :isAVLianmai="isAVLianmai"
      :lianmaiCount="lianmaiCount" :applyUserTotalCount="applyUserList.length"
      @clodeSettingDialog="openCloseSetting" @changeIsAVLianmai="changeIsAVLianmai"></LianmaiSetting>

    <!-- 连麦开关 -->
    <div class="lianmai-switch fontsize12" v-show="role===3">
      <span class="fontColor">{{ $t("lianmai.连麦申请") }}</span>
      <el-switch class="blueSwitch form-dark" v-model="lianMaiStatus" @change="lianMaiStatusChange"
        :disabled="opType !== 0 || shareType == 4">
      </el-switch>
      <img class="setting" :src="require('@/svg/setting.svg')" @click="openCloseSetting"
        v-if="this.liveStartStatus == 2" />
    </div>
  </div>
</template>

<script>
import * as EventModule from "@/utils/checkOnline";
import Bus from "@/components/doc/bus";
import {
  getApplyUserRequestList,
  setVoiconpReply,
  updateVoipUserInfo,
  sendMsgToViewer,
  refuseUserVoip,
  searchVoipUserList,
  changeLianMaiStatus
} from "@/api/liveRequest/liveInfo";
import { pushRoomMessageFunc, removeMessageFunc } from "@/utils/socketMessageDispose";
import LianmaiSetting from "@/components/lianmai/setting";
import { mapGetters } from "vuex";

const MAX_LIAN_MAI_COUNT = 6; // 最大连麦人数

// import { Popconfirm } from "element-ui";
export default {
  name: "lianmai",
  components: {
    LianmaiSetting,
  },
  props: ["isOpenLianMai"],
  data() {
    return {
      applyUserList: [],
      searchApplyUserList: [],
      callApplyDialogVisible: false,
      callApplyTitle: "",
      refuseAllVisible: false,
      searchName: "",
      cacheSearchName: "",
      enabled: false,
      pageNo: 1,
      urlImag: `${process.env.VUE_APP_LAYOUT_API}/public/avatar.svg`,
      lianMaiStatus: false,
      EventOnliner: new EventModule.EventOnliner(),
      lianMaiKeepOnline: new Map(),
      showTips: false,
      isShowSetting: false,
      isAVLianmai: false,
      searchNameTimer: undefined,
      lianmaingApplyUserCount: 0,
      lianmaiCount: 0
    };
  },
  computed: {
    ...mapGetters(["liveConfig"]),
    userInfo() {
      return this.$store.getters.userInfo;
    },
    mediaStatus() {
      return this.$store.getters.mediaStatus;
    },
    chatRoomId() {
      return this.$store.getters.chatRoomId;
    },
    ccWebsocketClient() {
      return this.$store.getters.ccWebsocketClient;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
    shareType() {
      return this.$store.getters.shareType;
    },
    opType() {
      return this.$store.getters.opType;
    },
    used() {
      return this.$store.getters.used;
    },
    streamStatus() {
      return this.$store.getters.streamStatus;
    },
    voipInfo() {
      return this.$store.getters.voipInfo;
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    // 主控权   1：有  0：无
    avctl() {
      return (
        this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.avctl
      );
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type
      );
    }
  },
  watch: {
    streamStatus: {
      // 1:结束  0：开始 2：有流
      handler() {
        this.setLianMaiStatus();
      },
      immediate: true,
    },
    opType: {
      //opType:0 真直播   opType：3 伪直播    opType:2 第三方拉流
      handler() {
        this.setLianMaiStatus();
      },
      immediate: true,
    },
    used: {
      //是否使用0,1
      handler() {
        this.setLianMaiStatus();
      },
      immediate: true,
    },
    voipInfo: {
      handler(val) {
        this.lianMaiStatus = val.isJoinVoip == 0;
        this.isAVLianmai = val.isJoinVideo == 0;
      },
    },
    liveToken: {
      handler() {
        this.getApplyUserRequestList();
      },
    },
    role: {
      handler() {
        if (this.role == 3) { // 主播
          for (const [lianMaiId, lianMaiInfo] of this.lianMaiKeepOnline) {
            if (!this.EventOnliner.hasTimerById(lianMaiId)) {
              console.log('切换为主播身份, role: ' + this.role + ', need setHangUpTimeOut and update time, oldTime:' + lianMaiInfo.time + ',lianMaiId:', lianMaiId);
              lianMaiInfo.time = Date.now();
              this.setHangUpTimeOut(lianMaiInfo);
            }
          }
          this.getApplyUserRequestList();
        } else {
          for (const lianMaiId of this.lianMaiKeepOnline.keys()) {
            console.log('切换为非主播身份, role: ' + this.role + ', need clearTimerById lianMaiId:', lianMaiId);
            this.EventOnliner.clearTimerById(lianMaiId);
          }
        }
      }
    }
  },
  beforeDestroy() {
    removeMessageFunc(this.getCvMcRoomMessage);
  },
  async mounted() {
    if (this.liveToken) {
      await this.getApplyUserRequestList();
    }
    pushRoomMessageFunc(this.getCvMcRoomMessage);

    if (this.$store.getters.voipInfo) {
      this.lianMaiStatus = this.$store.getters.voipInfo.isJoinVoip == 0;
      this.isAVLianmai = this.$store.getters.voipInfo.isJoinVideo == 0;
    }

    this.addEvent();
    this.setLianMaiStatus();
  },
  methods: {
    getApplyUserCounts() {
      const applyUserCounts = {};

      for (const applyUser of this.applyUserList) {
        if (!applyUserCounts[applyUser.status])
          applyUserCounts[`status:${applyUser.status}`] = 0;

        applyUserCounts[`status:${applyUser.status}`]++;
      }

      return applyUserCounts;
    },
    isLianMaiOverrun() {
      return this.lianmaingApplyUserCount >= MAX_LIAN_MAI_COUNT;
      // return this.lianMaiKeepOnline.size >= MAX_LIAN_MAI_COUNT;
      // return (this.getApplyUserCounts()['status:2'] || 0) >= MAX_LIAN_MAI_COUNT;
    },
    showTipsTrue() {
      this.showTips = true;
    },
    setLianMaiStatus() {
      console.log('setLianMaiStatus role: ', this.role, ' ,opType:', this.opType, ' ,streamStatus:', this.streamStatus, ' ,used:', this.used, ' ,lianMaiStatus:', this.lianMaiStatus);
      if (this.role == 3 && this.opType == 2 && this.streamStatus != 1 && this.used == 0) {
        changeLianMaiStatus({ webcastId: this.liveId, status: 1, videoSwitch: this.isAVLianmai ? 0 : 1 }, this.liveToken);
        this.lianMaiStatus = false;
        this.refuseUserVoip();
      }
    },
    addEvent() {
      Bus.$on("pse:end:lianmai", async (resolve) => {
        changeLianMaiStatus({ webcastId: this.liveId, status: 1, videoSwitch: this.isAVLianmai ? 0 : 1 }, this.liveToken);
        this.lianMaiStatus = false;
        resolve(await this.refuseUserVoip());
      });
    },
    getCvMcRoomMessage(msg) {
      // console.log(msg, "lianmai");
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
        case 7127: {
          let _requestData = msg.requestData;
          if (_requestData.event && _requestData.event === "voIPApply") {
            //console.log('recv voIPApply _requestData:', JSON.stringify(_requestData));
            let _profile = _requestData.profile;
            if (_requestData.status === 4) {
              this.$message.warning(`${_profile.name}${this.$t("lianmai.已挂断连麦")}`);
            }
            console.log('fetch lianmai list',_requestData )
            this.getApplyUserRequestList();
          }
          if (
            _requestData.event &&
            _requestData.event === "monitor_voip_userlist_refresh"
          ) {
            this.getApplyUserRequestList();
          }
          if (_requestData.event && _requestData.event == "signal_message") {
            this.disposeCustomMessage_7127(JSON.parse(_requestData.message));
          }
          if (
            _requestData.status == "go_lianmai" ||
            _requestData.status == "online_lianmai"
          ) {
            this.disposeCustomMessage_7127(_requestData);
          }
          break;
        }
        case 7105: {
          console.log(msg, "7105 break;");
          this.disposeCustomMessage_7127(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "voIPReplyOwner": {
            //console.log('recv voIPReplyOwner requestData', JSON.stringify(requestData));
            this.$message.success(`${requestData.name}${this.$t("lianmai.连麦成功")}`);
            //  this.setHangUpTimeOut(requestData);
            //console.log(this.lianMaiKeepOnline, "this.lianMaiKeepOnline")
            this.getApplyUserRequestList();

            break;
          }
          case "voIpReplyAside": {
            //挂断
            let curHangupInfoId = `online_lianmai_${requestData.userId}`;
            let curHangupInfo = this.lianMaiKeepOnline.get(curHangupInfoId);
            //console.log('recv voIpReplyAside, curHangupInfoId:', curHangupInfoId, ' ,hasCurHangupInfo:', !!curHangupInfo, ' ,requestData:', JSON.stringify(requestData));
            if (curHangupInfo) {
              this.EventOnliner.clearTimer(curHangupInfo);
              //console.log('delete lianMaiKeepOnline item,lianMaiId:', curHangupInfoId);
              this.lianMaiKeepOnline.delete(curHangupInfoId);
              this.lianmaiCount = this.lianMaiKeepOnline.size;
            }
            this.getApplyUserRequestList();
            break;
          }
          case "voip_is_join_status": {
            this.lianMaiStatus = requestData.isJoinVoip == 0;
            this.enabled = requestData.enabled ? true : false;
            this.isAVLianmai = requestData.isJoinVideo == 0;

            let voipInfo = this.$store.getters.voipInfo;
            this.$store.commit(
              "SET_VOIPINFO",
              Object.assign(voipInfo, {
                isJoinVoip: requestData.isJoinVoip,
                isSystemJoinVoip: requestData.isSystemJoinVoip,
                isJoinVideo: requestData.isJoinVideo
              })
            );
            this.getApplyUserRequestList();
            break;
          }
          case 'voip_is_update_status': {
            console.log('recv voip_is_update_status, requestData:', JSON.stringify(requestData), ' ,lianMaiStatus:', this.lianMaiStatus, ' ,isAVLianmai:', this.isAVLianmai);
            this.isAVLianmai = requestData.isJoinVideo == 0;
            break;
          }
          case 'monitor_voip_user_device_change': {
            console.log('recv monitor_voip_user_device_change, requestData:', JSON.stringify(requestData), ' ,lianMaiStatus:', this.lianMaiStatus, ' ,isAVLianmai:', this.isAVLianmai);
            this.updateLocalVoipUser(requestData.userId, undefined, { videoDevice: requestData.videoDevice, audioDevice: requestData.audioDevice });
            break;
          }
        }
      }
    },
    disposeCustomMessage_7127(requestData) {
      if (requestData.status == "go_lianmai") {
        let lianMaiId = `${requestData.status}_${requestData.uid}`;
        console.log('recv go_lianmai, hasCurLianMai:', this.lianMaiKeepOnline.has(lianMaiId), ' ,lianMaiId:', lianMaiId);
        // TODO qgs 这里先注释掉，看下没有 lianMaiKeepOnline 是否会产生影响
        this.EventOnliner.clearTimer(requestData);
        this.setVoipReplyFunc(requestData, "2");

        // if (!this.lianMaiKeepOnline.has(lianMaiId)) {
        //   this.EventOnliner.clearTimer(requestData);
        //   this.setVoipReplyFunc(requestData, "2");
        // } else {
        //   this.EventOnliner.clearTimer(requestData);
        // }
      } else if (requestData.status == "online_lianmai") {
        let lianMaiId = `${requestData.status}_${requestData.uid}`;
        var curLianMai = this.lianMaiKeepOnline.get(lianMaiId);
        if (curLianMai) {
          const oldTime = curLianMai.time;
          curLianMai.time = new Date().getTime();
          curLianMai.diffRecvTs = curLianMai.time - oldTime;
          curLianMai.oldSendTime = curLianMai.sendTime;
          curLianMai.sendTime = requestData.sendTime;
          // this.role == 3 && console.log('recv online_lianmai update curLianMai time:', curLianMai.time, ' ,diffTs:', curLianMai.diffRecvTs, ' ,sendTime:', requestData.sendTime, ' ,diffSendTs:', !requestData.sendTime ? undefined : (requestData.sendTime - curLianMai.oldSendTime), ' ,lianMaiId:', lianMaiId);
        } else {
          console.log('set lianMaiKeepOnline item,lianMaiId:', lianMaiId, ' ,role:', this.role);
          let lianMaiInfo = {
            type: "viewer_apply",
            status: "online_lianmai",
            token: requestData.token,
            sendTime: requestData.sendTime,
            oldSendTime: requestData.sendTime,
            uid: requestData.userId || requestData.uid || requestData.roomUid,
            time: new Date().getTime(),
            Timer: null
          };
          this.lianMaiKeepOnline.set(lianMaiId, lianMaiInfo);
          this.lianmaiCount = this.lianMaiKeepOnline.size;

          if (this.role == 3 && !this.EventOnliner.hasTimerById(lianMaiId)) {
            console.log('主播身份 recv online_lianmai, need setHangUpTimeOut lianMaiId:', lianMaiId);
            this.setHangUpTimeOut(lianMaiInfo);
          }
        }
      }
    },
    setHangUpTimeOut(lianMaiInfo) {
      const lianMaiId = `${lianMaiInfo.status}_${lianMaiInfo.uid}`;

      if (this.EventOnliner.hasTimerById(lianMaiId))
        return;

      console.log('setHangUpTimeOut exec addOnlieTimer lianMaiInfo:', JSON.stringify(lianMaiInfo), ' ,lianMaiId:', lianMaiId);
      this.EventOnliner.addOnlieTimer(lianMaiInfo, 2000, (info) => {
        let curLianMaiInfo = this.lianMaiKeepOnline.get(lianMaiId);
        if (!curLianMaiInfo) {
          console.log('setHangUpTimeOut addOnlieTimer trigger callback, but EMPTY curLianMaiInfo, info:', info && JSON.stringify(info), ' ,lianMaiId:', lianMaiId);
          this.EventOnliner.clearTimer(info);
          return;
        }

        let curLianMaiTime = new Date().getTime();
        const diffTs = curLianMaiTime - curLianMaiInfo.time;
        // console.log("lianmai ping时间", curLianMaiInfo.time, ' ,diffTs:', diffTs, ' ,curLianMaiTime:', curLianMaiTime, ' ,lianMaiId:', lianMaiId);
        if (diffTs > 4000) {
          console.log('4s内没有收到连麦发的ping, need delete lianMaiKeepOnline item,lianMaiId:', lianMaiId);
          this.EventOnliner.clearTimerById(lianMaiId);
          this.lianMaiKeepOnline.delete(lianMaiId);

          let curLianMaiToken = this.applyUserList.find((info) => {
            return info.roomUid == curLianMaiInfo.uid;
          });

          console.log("4s内没有收到连麦发的ping, info:", info && JSON.stringify(info), ' ,diffTs:', diffTs, ' ,curLianMaiTime:', curLianMaiTime, ", curLianMaiToken:", curLianMaiToken && JSON.stringify(curLianMaiToken), ' ,lianMaiId:', lianMaiId);

          if (
            info &&
            info.uid &&
            curLianMaiToken &&
            info.uid == curLianMaiToken.roomUid &&
            curLianMaiToken &&
            curLianMaiToken.token
          ) {
            console.log('4s内没有收到连麦发的ping, 心跳超时暂时先不挂掉连麦, lianMaiId:', lianMaiId);

            // TODO qgs 这里先注释掉，心跳超时暂时先不挂掉连麦
            // console.log('4s内没有收到连麦发的ping, setVoipReplyFunc to 3, lianMaiId:', lianMaiId);
            // this.setVoipReplyFunc(curLianMaiToken, "3");

            // this.$message.warning(`${curLianMaiToken.name}${this.$t("lianmai.观众已经退出连麦")}`);
          }
        }
      });
    },
    //获取连麦申请列表
    getApplyUserRequestList() {
      if (!this.liveToken) return;
      console.log('獲取連麥列表')
      getApplyUserRequestList(this.liveToken).then((res) => {
        if (res.code === 200) {
          const applyUserListTmp = res.data.reverse();
          this.sortLianMai(applyUserListTmp);

          const lianmaingApplyUsers = {};
          const requestingApplyUsersKeys = [];
          const notEsxitApiListKeepOnlineKeys = [];
          for (const applyUser of applyUserListTmp) {
            if (applyUser.status !== 2) {
              requestingApplyUsersKeys.push(`${applyUser.status}_${applyUser.roomUid}`);
              continue;
            }

            lianmaingApplyUsers[`online_lianmai_${applyUser.roomUid}`] = 1;
          }
          const lianmaingApplyUserKeys = Object.keys(lianmaingApplyUsers);
          this.lianmaingApplyUserCount = lianmaingApplyUserKeys.length;
         

          const lianMaiKeepOnlineKeys = Array.from(this.lianMaiKeepOnline.keys());

          for (const lianMaiId of lianMaiKeepOnlineKeys) {
            if (lianmaingApplyUsers[lianMaiId]) continue;
            notEsxitApiListKeepOnlineKeys.push(lianMaiId);
          }

          console.log(
            'getApplyUserRequestList success, listLength: ' + applyUserListTmp.length, ' ,lianmaingApplyUserCount:', this.lianmaingApplyUserCount,
            ' ,notEsxitApiListKeepOnlineKeys:', JSON.stringify(notEsxitApiListKeepOnlineKeys),
            ' ,lianMaiKeepOnlineKeys:', JSON.stringify(lianMaiKeepOnlineKeys),
            ' ,lianmaingApplyUserKeys:', JSON.stringify(lianmaingApplyUserKeys),
            ' ,requestingApplyUsersKeys:', JSON.stringify(requestingApplyUsersKeys)
          );

          this.applyUserList = applyUserListTmp;
          this.$emit("update:lianmais", this.applyUserList.length);
          this.logger.info({ code: 2018, message: this.applyUserList });
        }
      });

      if (this.searchName) {
        this.searchVoipUserListFunc();
      }
    },
    // 连麦方放到前面
    sortLianMai(applyUserList) {
      applyUserList.sort((a, b) => {
        if (a.status === 2 && b.status !== 2) {
          return -1; // a 的 status 为 2，应该在前面
        } else if (a.status !== 2 && b.status === 2) {
          return 1; // b 的 status 为 2，应该在前面
        } else {
          return 0; // 不需要交换位置
        }
      });
    },
    //  拒绝所有申请
    refuseUserVoip() {
      refuseUserVoip(this.liveToken).then(() => { });
    },
    searchFunc(isFoeceUpdate) {
      if (!isFoeceUpdate && this.searchNameTimer && this.cacheSearchName)
        return;

      this.searchNameTimer && clearTimeout(this.searchNameTimer);
      this.searchNameTimer = undefined;

      if (!isFoeceUpdate && this.cacheSearchName) {
        this.searchNameTimer = setTimeout(() => {
          this.searchNameTimer && clearTimeout(this.searchNameTimer);
          this.searchNameTimer = undefined;
          this.searchFuncEx();
        }, 500);
        return;
      }

      this.searchFuncEx();
    },
    searchFuncEx() {
      if (this.cacheSearchName === this.searchName) {
        return;
      }
      this.pageNo = 1;
      this.searchName = this.cacheSearchName;
      if (this.searchName) {
        this.searchVoipUserListFunc();
        return;
      }

      this.searchApplyUserList = [];
      this.getApplyUserRequestList();
    },
    /**连麦列表搜索 */
    searchVoipUserListFunc() {
      searchVoipUserList(
        {
          name: this.searchName,
          pageNo: this.pageNo,
          pageSize: 50,
        },
        this.liveToken
      )
        .then((res) => {
          console.log(res, "搜索出来的人");
          if (res.code === 200) {
            if (!this.searchName) {
              console.log('empty searchName ignore searchVoipUserList');
              return;
            }

            const searchApplyUserListTmp = res.data.list;
            this.sortLianMai(searchApplyUserListTmp);
            this.searchApplyUserList = searchApplyUserListTmp;
          }
        })
        .catch((err) => {
          console.log(err, "err_searchVoipUserList");
        });
    },
    clearSearchFunc() {
      this.searchName = this.cacheSearchName;
      this.searchNameTimer && clearTimeout(this.searchNameTimer);
      this.searchNameTimer = undefined;
      this.searchApplyUserList = [];
      this.getApplyUserRequestList();
    },
    async setAgreeReplyFunc(item) {
      if (this.EventOnliner.hasTimerById(`go_lianmai_${item.roomUid}`)) {
        console.log('clicked agree btn, uid:', item.roomUid);
        return;
      }

      if (this.isLianMaiOverrun()) {
        this.$message.error(this.$t('lianmai.连麦人数已达上限'));
        return;
      }

      if (
        this.liveConfig.liveondemandVoiceStatus === 0 &&
        (this.mediaStatus == 2 || this.mediaStatus == 3)
      ) {
        this.$message.error(this.$t("lianmai.插播静音已开启，您暂时不能开启连麦"));
        return;
      }

      let onlineData = {
        type: "assistant_apply",
        status: "agree_lianmai",
        token: item.token,
        uid: item.roomUid,
      };
      let viewerApply = {
        Timer: null,
        time: 0,
        type: "viewer_apply",
        status: "go_lianmai",
        token: item.token,
        uid: item.roomUid,
        data: JSON.parse(JSON.stringify(item))
      };
      await sendMsgToViewer(
        { webcastId: this.liveId, userId: item.roomUid },
        onlineData,
        this.liveToken
      );

      console.log('setAgreeReplyFunc exec addOnlieTimer viewerApply:', JSON.stringify(viewerApply));
      this.EventOnliner.addOnlieTimer(
        viewerApply,
        4000,
        (info) => {
          this.EventOnliner.clearTimer(info);

          let curLianMaiToken = this.applyUserList.find((infos) => {
            return infos.roomUid == info.uid;
          });

          console.log('setAgreeReplyFunc addOnlieTimer trigger callback info:', info && JSON.stringify(info), ' ,curLianMaiToken.status:', curLianMaiToken && curLianMaiToken.status, ' ,curLianMaiToken:', curLianMaiToken && JSON.stringify(curLianMaiToken));

          // 挂断
          if ((!curLianMaiToken || curLianMaiToken.status !== 2) && info && info.data) {
            console.log('setAgreeReplyFunc trigger timeout, setVoipReplyFunc to 3, info.data:', info.data);
            this.setVoipReplyFunc(info.data, "3");
          }

          if (curLianMaiToken && curLianMaiToken.status !== 2) {
            console.log('setAgreeReplyFunctrigger timeout, 观众已经退出连麦, curLianMaiToken:', JSON.stringify(curLianMaiToken));
            this.$message.warning(`${curLianMaiToken.name}${this.$t("lianmai.观众已经退出连麦")}`);
          } else if (curLianMaiToken && curLianMaiToken.status === 2) {
            console.log('setAgreeReplyFunctrigger timeout, 观众已经连麦中, 不进行处理, curLianMaiToken:', JSON.stringify(curLianMaiToken));
          }
        }
      );
      this.showTips = false;
    },
    setVoipReplyFunc(item, typeVal) {
      console.log('call setVoipReplyFunc item:', JSON.stringify(item), ' ,typeVal:', typeVal);

      const fromData = new FormData();
      fromData.append("token", item.token);
      fromData.append("type", parseInt(typeVal));
      fromData.append("unKick", 1);

      setVoiconpReply(fromData, this.liveToken).then((res) => {
        console.log('setVoipReplyFunc setVoiconpReply res:', JSON.stringify(res), ' ,item:', JSON.stringify(item), ' ,typeVal:', typeVal);

        if (res.code == 6000) {
          this.$message.error(this.$t("lianmai.当前人数已满"));
        }
        if (res.code == 6043) {
          this.$message.error(this.$t("lianmai.服务已停用"));
        }
        if (res.code == 1003) {
          this.$message.error(this.$t("lianmai.连麦人数已达上限"));
        }
      }).catch((err) => {
        console.error('setVoipReplyFunc setVoiconpReply catch err:', err, ' ,item:', JSON.stringify(item), ' ,typeVal:', typeVal);
      });
    },
    lianMaiStatusChange(value) {
      if (this.liveStartStatus != 2) {
        this.lianMaiStatus = false;
        this.$message.error(this.$t("lianmai.请先开启直播"));
        return;
      }
      Bus.$on('voipStatus', val => {
        const tipsContent =
          val == 1
              ? this.$t("aside-left.直播间连麦已禁用")
              : this.$t("aside-left.直播间连麦已开放");
          this.$message.success(`${tipsContent}`);
          Bus.$off('voipStatus');
      })
      if (value == false) {
        this.$confirm(this.$t("lianmai.您确定关闭连麦功能吗"), this.$t("lianmai.提示"), {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t("lianmai.确定"),
          cancelButtonText: this.$t("lianmai.取消"),
        })
          .then(() => {
            changeLianMaiStatus(
              { webcastId: this.liveId, status: value ? 0 : 1, videoSwitch: this.isAVLianmai ? 0 : 1 },
              this.liveToken
            ).then((res) => {
              if (res.code != 200) {
                this.lianMaiStatus = !value;
              }
            });
          })
          .catch(() => {
            this.lianMaiStatus = !this.lianMaiStatus;
          });
      } else {
        changeLianMaiStatus(
          { webcastId: this.liveId, status: value ? 0 : 1, videoSwitch: this.isAVLianmai ? 0 : 1 },
          this.liveToken
        ).then((res) => {
          if (res.code != 200) {
            this.lianMaiStatus = !value;
          }
          
        });
      }
    },
    openCloseSetting() {
      console.log('call openCloseSetting, isShowSetting:', this.isShowSetting);
      this.isShowSetting = !this.isShowSetting;
    },
    changeIsAVLianmai() {
      console.log('call changeIsAVLianmai, isAVLianmai:', this.isAVLianmai);
      const newIsAVLianmai = !this.isAVLianmai;

      if (this.applyUserList.length > 0) {
        console.log('changeIsAVLianmai need refuseUserVoip, applyUserListLength:', this.applyUserList.length, ' ,newIsAVLianmai:', newIsAVLianmai);
        this.refuseUserVoip();
      }

      console.log('changeIsAVLianmai need changeLianMaiStatus update isAVLianmai setting, set isAVLianmai to ', newIsAVLianmai);
      changeLianMaiStatus(
        { webcastId: this.liveId, status: this.lianMaiStatus ? 0 : 1, videoSwitch: newIsAVLianmai ? 0 : 1 },
        this.liveToken
      ).then((res) => {
        console.log('changeIsAVLianmai changeLianMaiStatus code:', res.code);
      });
    },
    handleClodeSettingDialog() {
      this.isShowSetting = false;
    },
    changeVoipUserAVDeviceStatusAPI(avType, uid, cid, token, updatedStatus) {
      console.log('call changeVoipUserAVDeviceStatusAPI avType:', avType, ' ,uid:', uid, ' ,cid:', cid, ' ,updatedStatus:', updatedStatus);
      const fromData = new FormData();
      fromData.append("token", token);

      const updateJson = {};

      switch (avType) {
        case 'video': {
          fromData.append("videoDevice", updatedStatus);
          updateJson['videoDevice'] = updatedStatus;
          break;
        }
        case 'audio': {
          fromData.append("audioDevice", updatedStatus);
          updateJson['audioDevice'] = updatedStatus;
          break;
        }
      }

      updateVoipUserInfo(fromData, this.liveToken).then((res) => {
        console.log('changeVoipUserAVDeviceStatusAPI updateVoipUserInfo res:', res, ' ,avType:', avType, ' ,uid:', uid, ' ,updatedStatus:', updatedStatus);
        if (res.code === 200) {
          // this.getApplyUserRequestList();
          this.updateLocalVoipUser(uid, cid, updateJson);
        }
      });
    },
    updateLocalVoipUser(uid, cid, updateJson) {
      let isExistUser = false;

      for (const applyUser of this.applyUserList) {
        if (applyUser.uid === uid && (cid === undefined || applyUser.cid === cid)) {
          isExistUser = true;
          Object.assign(applyUser, updateJson);
          break;
        }
      }

      for (const applyUser of this.searchApplyUserList) {
        if (applyUser.uid === uid && (cid === undefined || applyUser.cid === cid)) {
          isExistUser = true;
          Object.assign(applyUser, updateJson);
          break;
        }
      }

      if (!isExistUser)
        this.getApplyUserRequestList();
    },
    switchParticipantAVStatusFunc(avType, item) {
      if (item.status !== 2) { // 不是连麦中，不允许控制音视频开关
        this.$message.error(this.$t("lianmai.未连麦时无法切换设备状态"));
        return;
      }

      if (this.avctl !== 1) { // 需要获取主控权
        this.$message.error(this.$t("lianmai.需要获取主控权"));
        return;
      }

      console.log('call switchParticipantAVStatusFunc avType:', avType, ' ,item:', JSON.stringify(item));
      switch (avType) {
        case 'video': {
          if (!item.videoDevice)
            break;

          const { videoDevice, uid, cid, token } = item;
          const status = videoDevice === 1 ? 'inactive' : 'active';
          console.log('switchParticipantAVStatusFunc start handleParticipantCamera status:', status, ' ,uid:', uid, ' ,cid:', cid);
          this.rtcClient.RTCRoom.handleParticipantCamera(uid, cid, status).then((res) => {
            console.log('switchParticipantAVStatusFunc handleParticipantCamera res:', res, ' ,status:', status, ' ,uid:', uid, ' ,cid:', cid);
            if (res && res.status === 200) {
              this.changeVoipUserAVDeviceStatusAPI(avType, uid, cid, token, videoDevice === 1 ? 2 : 1);
            }
          });
          break;
        }
        case 'audio': {
          if (!item.audioDevice)
            break;

          const { audioDevice, uid, cid, token } = item;
          const status = audioDevice === 1 ? 'inactive' : 'active';
          console.log('switchParticipantAVStatusFunc start muteParticipant status:', status, ' ,uid:', uid, ' ,cid:', cid);
          this.rtcClient.RTCRoom.muteParticipant(uid, cid, status).then((res) => {
            console.log('switchParticipantAVStatusFunc muteParticipant res:', res, ' ,uid:', uid, ' ,cid:', cid);
            if (res && res.status === 200) {
              this.changeVoipUserAVDeviceStatusAPI(avType, uid, cid, token, audioDevice === 1 ? 2 : 1);
            }
          });
          break;
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.lianmai-container {
  z-index: 1;
  background-color: $dialog-bg-color;
  position: absolute;
  left: 50px;
  border-radius: 6px;
  padding: 20px;
  bottom: 60px;

  .lianmai-list {
    width: 320px;

    .lianmai-list-header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      color: $white-color;
    }

    .lianmai-refuseAll {
      color: $bule-color;
    }

    .lianmai-list-search {
      width: 100%;
      margin: 15px 0px;
      position: relative;
    }

    .controller-list {
      height: 200px;
    }

    .controller-list-content {
      color: $white-color;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 5px;

      .controller-icon {
        display: inline-block;
        overflow: hidden;
        vertical-align: middle;
        margin-right: 5px;

        >img {
          filter: drop-shadow(#818499 80px 0);
          -webkit-filter: drop-shadow(#818499 80px 0);
          transform: translateX(-80px);
        }
      }

      .device-icon {
        >img {
          margin-right: 14px;
          cursor: pointer;
          width: 13px;
        }

        .opacity-0 {
          opacity: 0 !important;
          pointer-events: none !important;
          cursor: none !important;
        }

        .disabled {
          opacity: 0.4;
          pointer-events: none;
          cursor: none;
        }
      }
    }

    .controller-list-name {
      // max-width: 122px;
      text-align: left;
      flex: 1;
      padding-right: 5px;
    }
  }

  .lianmai-switch {
    color: $white-color;
    display: flex;
    min-width: 100px;
    border-top: 1px solid;
    @include border_color('searchInnerBg');
    padding-top: 10px;
    .blueSwitch {
      border: none !important;
    }
    .setting {
      justify-content: flex-end;
      margin-left: auto;
    }
  }

  .lianmaing {
    color: #3986ee;
    margin-right: 26px;
  }
  .lianmaiconnect {
    color: #8a8f99;
    margin-right: 26px;
  }
}
[data-theme=Orange] .lianmai-container .lianmaing{
  color: #F89B33;
}
.lianmai-container-guest{
  bottom: 0;
}
</style>
